module.exports = __webpack_public_path__ + "static/img/day6.042f456.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/day6.jpg
// module id = Ng7o
// module chunks = 0